export default {
    required: 'Поле не заполнено',
    minLength: (min: number) => `Минимально ${min} символа(ов)`,
    maxLength: (max: number) => `Максимально ${max} символа(ов)`,
    email: 'Некорректный формат эл. почты',
    url: 'Введен неправильный URL',
    urlWithDomainZone: 'Введен неправильный URL',
    urlWithProtocolAndParams: 'Не указан протокол http или https',
};
